export const LOGIC_OPERATIONS = ['and', 'or', 'not'];

export const SEGMENT_NAME_BY_INDEX = ['A', 'B', 'C'];

export const RELATIONS = {
  AB: [0, 1],
  BC: [1, 2],
  AC: [0, 2],
  ABC: [0, 1, 2],
};

export const GSQL_PREFIX = '';
export const GSQL_PARAMS = [
  'checkAB=false',
  'checkBC=false',
  'checkAC=false',
  'checkABC=false',
  'logicForFiltersA=0',
  'logicForFiltersB=0',
  'logicForFiltersC=0',
].join('&');

export const DEFAULT_GSQL = `${GSQL_PREFIX}${GSQL_PARAMS}`;

export const DRAGGABLE_ITEM_TYPES = {
  LEFT_SIDEBAR_GROUP_ITEM: 'LEFT_SIDEBAR_GROUP_ITEM',
  LEFT_SIDEBAR_SEGMENT_FILTER_ITEM: 'LEFT_SIDEBAR_SEGMENT_FILTER_ITEM',
};

export const FILTERS_FLAGS = [
  'CB_Mobile',
  'CB_Fix',
  'Prospect_Mob',
  'Prospect_Fisso',
  'Prospect_Fix',
  'Unica_Fix',
  'Unica_Mob',
  'Bu_Tim_Performance_Store',
  'Bu_Tim_Mondo_Digitale',
  'Tim_Performance_Store',
  'Tim_Digital_Store',
  'Tim_Music_Customers',
];

export default {
  LOGIC_OPERATIONS,
  SEGMENT_NAME_BY_INDEX,
  RELATIONS,
  DEFAULT_GSQL,
  GSQL_PREFIX,
  DRAGGABLE_ITEM_TYPES,
  FILTERS_FLAGS,
};
